import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { getText } from '../../../../internal/TextLabels'
import { format } from '../../../../models/format'
import {
  naturalGovIdPlaceholder,
  validateAge,
  validateNaturalGovernmentId,
} from '../../../../util/governmentIdUtils'
import TextInput from '../../../../midasComponents/components/TextInput'

const testRegex = (countryCode, governmentId) =>
  new RegExp(format.governmentId[countryCode].regex).test(governmentId)

const GovernmentIdInput = ({
  countryCode,
  language,
  governmentId,
  updateGovernmentId,
  disabled,
}) => {
  const [rawValue, setRawValue] = useState(governmentId)
  const [trimmedValue, setTrimmedValue] = useState(governmentId)

  useEffect(() => {
    const trimmedGovId = (rawValue || '').trim()
    updateGovernmentId(trimmedGovId)
    setTrimmedValue(trimmedGovId)
  }, [rawValue])

  const getHint = () => {
    if (
      trimmedValue &&
      testRegex(countryCode, trimmedValue) &&
      !validateNaturalGovernmentId(countryCode, trimmedValue)
    ) {
      return getText('payApply.applicant.governmentIdNotValidError')
    }

    if (
      trimmedValue &&
      testRegex(countryCode, trimmedValue) &&
      !validateAge(countryCode, trimmedValue)
    ) {
      return getText('payApply.applicant.underAgedCustomer')
    }

    return null
  }
  return (
    <TextInput
      id="government-id"
      format={format.governmentIdWithWhitespace[countryCode]}
      placeholder={naturalGovIdPlaceholder(countryCode, language)}
      value={rawValue}
      required={getText('payApply.applicant.required')}
      onChange={e => setRawValue(e.target.value.toUpperCase())}
      disabled={disabled}
      isValid={() =>
        trimmedValue &&
        validateAge(countryCode, trimmedValue) &&
        validateNaturalGovernmentId(countryCode, trimmedValue)
      }
      disableAutocomplete
      autoFocus
      additionalValidation={input => getHint(input)}
    />
  )
}

GovernmentIdInput.propTypes = {
  countryCode: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired,
  governmentId: PropTypes.string,
  disabled: PropTypes.bool,
  updateGovernmentId: PropTypes.func.isRequired,
}

GovernmentIdInput.defaultProps = {
  governmentId: '',
  disabled: false,
}

export default GovernmentIdInput
